import {trans} from '../../../l10n';
import mix from '../../../helpers/mix';
import React from 'react';
import {h, Fragment} from 'preact';

export default function LikeButton(props) {
    const {product, view} = props;

    if (global.config.isOperator) {
        return (
            <div
                className={'like-btn grid ' + (view === 'grid') ? '' : ' hidden'}
                style={{marginTop: '10px', border: 0, background: 'none'}}>
                <a
                    href='#'
                    className='js-interest-toggle'
                    data-good-id={product.id}
                    title={trans('catalog.interest')}
                    style={{padding: '0', background: 'none'}}>
                    <img src={mix.img('images/vopros.jpg')} width='20' />
                </a>
            </div>
        );
    }

    return (
        <div
            className={'like-btn grid ' + (product.favorite ? 'active' : '') + (view === 'grid' ? '' : ' hidden')}
            style={{marginTop: '1px'}}>
            <a
                href='#'
                className='js-favorite-toggle'
                data-good-id={product.id}
                title={trans('catalog.add_to_favorite')}></a>
        </div>
    );
}
